import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import AdminSidebar from "@/components/admin/AdminSidebar";
import { useAuth } from "@/contexts/AuthContext";

export function AdminLayout() {
    const { admin } = useAuth();
    const loc = useLocation();
    if (admin === null) {
        return (
            <div className="flex h-screen items-center justify-center bg-md-bg text-md-text-2">
                <div className="animate-pulse text-sm">Vérification de la session admin…</div>
            </div>
        );
    }
    if (admin === false) {
        return <Navigate to="/admin/login" replace state={{ from: loc }} />;
    }
    return (
        <div className="flex min-h-screen bg-md-bg">
            <AdminSidebar />
            <main className="flex-1 overflow-x-hidden">
                <div className="mx-auto max-w-[1400px] px-6 py-8 lg:px-10">
                    <Outlet />
                </div>
            </main>
        </div>
    );
}

export default AdminLayout;
